export default {"src":"/_next/static/media/unpublished-light.a35f9109.svg","height":256,"width":256};